import { inject, Injectable } from '@angular/core';
import { Actions, ofActionErrored, ofActionSuccessful, Store } from '@ngxs/store';
import { NotificationService } from '@tran-monorepo/frontend/services/notification.service';
import { Observable, tap } from 'rxjs';
import { DeleteApplication } from '../state/applications-overview/applications-overview.action';

@Injectable({
    providedIn: 'root'
})
export class ApplicationActionsService {
    private readonly store = inject(Store);
    private readonly actions$ = inject(Actions);
    private readonly notifications = inject(NotificationService);

    constructor() {
        this.setupActionHandlers();
    }

    public deleteApplication(applicationId: string): Observable<void> {
        return this.store.dispatch(new DeleteApplication(applicationId));
    }

    private setupActionHandlers(): void {
        // Handle DeleteApplication success
        this.actions$
            .pipe(
                ofActionSuccessful(DeleteApplication),
                tap(() =>
                    this.notifications.notify('success', 'applications.overview.notifications.delete-draft.success')
                )
            )
            .subscribe();

        // Handle DeleteApplication error
        this.actions$
            .pipe(
                ofActionErrored(DeleteApplication),
                tap(() => this.notifications.notify('danger', 'applications.overview.notifications.delete-draft.error'))
            )
            .subscribe();
    }
}
